import { MonthView } from '@devexpress/dx-react-scheduler-material-ui';
import { useIsSmallScreen } from '../../../../../../../../Hooks/useFullscreenView';
import { SchedulerContext } from '../../SchedulerContext';
import { useContext } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  customMonthAppointmentLayerComponent: {
    top: '20px !important',
  },
}));

export const CustomMonthAppointmentLayerComponent = (
  props: MonthView.AppointmentLayerProps
) => {
  const { classes, cx } = useStyles();

  const schedulerContext = useContext(SchedulerContext);
  const isSmallScreen = useIsSmallScreen();
  return (
    <MonthView.AppointmentLayer
      {...props}
      className={cx({
        [classes.customMonthAppointmentLayerComponent]:
          schedulerContext.overView && isSmallScreen,
      })}
    ></MonthView.AppointmentLayer>
  );
};
